import React from 'react'
import PropTypes from 'prop-types'
import { Box, Stack, Flex, Image } from '@chakra-ui/react'
import { loadImage } from 'integrations/unsplash'
import dynamic from 'next/dynamic'

const BannerTitle = dynamic(() =>
  import(
    /* webpackChunkName: 'BannerTitle' */ '../../../../../../components/home-page/views/sections/banner/components/title'
  )
)
const BannerDescription = dynamic(() =>
  import(
    /* webpackChunkName: 'BannerDescription' */ '../../../../../../components/home-page/views/sections/banner/components/description'
  )
)
const BannerCTA = dynamic(() =>
  import(
    /* webpackChunkName: 'BannerCTA' */ '../../../../../../components/home-page/views/sections/banner/components/cta'
  )
)

const BannerLayoutSix = ({ data, theme, meta, brandColor }) => {
  const isNotInFull = !data.fullHeight

  return (
    <Flex>
      <Box w='full'>
        <Image
          w='full'
          src={loadImage(data.image, meta.imageSize || 1000, 2500)}
          alt={!data.altText ? '' : data.altText}
          backgroundPosition={`${data.imgFocalX}% ${data.imgFocalY}%`}
          className='ehq--mb-2'
        />

        {isNotInFull && (
          <Box px={[4, 4, 16, 16]} py={[4, 4, 0, 0]} bg={theme.backgroundColor}>
            <Flex
              alignItems='center'
              bg={theme.backgroundColor}
              flexDir='column'
              justifyContent='center'
              p={[0, 0, 12, 12]}
              py={[4, 8, 8, 8]}
              textAlign='center'
              w='full'
              m='auto'
              maxW='6xl'
            >
              <Stack spacing={4} w='full'>
                <Flex>
                  <BannerTitle theme={theme} data={data} />
                </Flex>
                <Box>
                  <BannerDescription theme={theme} data={data} brandColor={brandColor}/>
                </Box>
                <Box>
                  <BannerCTA theme={theme} data={data} />
                </Box>
              </Stack>
            </Flex>
          </Box>
        )}
      </Box>
    </Flex>
  )
}

BannerLayoutSix.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  meta: PropTypes.object,
  brandColor: PropTypes.string.isRequired
}

export default BannerLayoutSix
